import type { Offer } from '~/models/Offers';
/**
 * @see https://nuxt.com/docs/getting-started/state-management#shared-state
 * @returns Ref<Offer>
 */
export const useCurrentOfferState = () => useState<Offer>('currentOfferState');
